import {
  Avatar,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Show,
  Text
} from "@chakra-ui/react";
import React from "react";
import useSignOut from "react-auth-kit/hooks/useSignOut";
import {
  RiLogoutBoxLine,
  RiUserLine,
  RiMenuFill,
  RiServerLine,
  RiHome2Line,
  RiRemoteControl2Line
} from "react-icons/ri";
import { useNavigate } from "react-router";
import { useAuth } from "store/hooks/useAuth";
import { useToken } from "store/hooks/useToken";
import { hasModuluesAccess } from "utils/modules-access";
import { getFullPathEnv } from "utils/pathEnv";
import { PrivateModule } from "_config/routes/base/PrivateModule";
import { useTypedSelector } from "../../../store/hooks";
import { AdminAccessButton } from "./AdminAccessButton";

type Props = {
  showName?: boolean;
};

export const UserDescription = ({ showName }: Props) => {
  const user = useAuth();
  const navigate = useNavigate();
  const hasModules = hasModuluesAccess();
  const { getTokenPayload } = useToken();
  const logout = useSignOut();

  const userData = getTokenPayload();

  const { successPayload } = useTypedSelector(
    (state) => state.configuracao.obterConfiguracao
  );

  const signOut = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();

    logout();
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  return (
    <Flex ml="6">
      <AdminAccessButton renderIn="desktop" userData={userData} />
      <Menu strategy="fixed" isLazy>
        <MenuButton>
          <Show below="sm">
            <RiMenuFill fontSize="1.5rem" />
          </Show>
          <Show above="sm">
            <Flex alignItems="center">
              <Avatar
                size={"sm"}
                bg={`${successPayload?.corTema.nome}.500`}
                color="gray.50"
                name={user?.nome?.toUpperCase()}
                mr={2}
                opacity={0.6}
              />
              {showName && (
                <Text
                  color={"gray.600"}
                  textAlign="left"
                  fontSize="sm"
                  fontWeight="medium"
                  maxW="140px"
                  isTruncated
                >
                  {user?.nome?.split(" ").slice(0, 2).join(" ")}
                </Text>
              )}
            </Flex>
          </Show>
        </MenuButton>
        <MenuList py="2">
          <Show below="sm">
            <MenuItem
              onClick={() => navigate("/")}
              icon={<RiHome2Line fontSize="1.1rem" />}
              py="2"
            >
              Início
            </MenuItem>
            {hasModules && (
              <MenuItem
                onClick={() => navigate("/servicos-disponiveis")}
                icon={<RiServerLine fontSize="1.1rem" />}
                py="2"
              >
                Serviços
              </MenuItem>
            )}
            <PrivateModule modules={["LICENCIAMENTO_URBANO"]}>
              <MenuItem
                onClick={() =>
                  navigate("/licenciamento-urbano/meus-requerimentos")
                }
                icon={<RiRemoteControl2Line fontSize="1.1rem" />}
                py="2"
              >
                Meus requerimentos
              </MenuItem>
            </PrivateModule>
          </Show>

          <MenuItem
            onClick={() => {
              const baseUrl = getFullPathEnv("REACT_APP_IDENTITY_URL");
              window.open(baseUrl, "_blank");
            }}
            icon={<RiUserLine fontSize="1.1rem" />}
            py="2"
          >
            Gerenciar perfil
          </MenuItem>
          <AdminAccessButton renderIn="mobile" userData={userData} />
          <MenuItem
            onClick={signOut}
            icon={<RiLogoutBoxLine fontSize="1.1rem" />}
            py="2"
          >
            Sair
          </MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  );
};
